import React from 'react';

const Legal = ({ content }) => {
    return (
        <div className='legal-pg'>

            {/* inner-banner section start */ }
            <div className="innerBaneer no-image">
                <div className="container">
                    <div className="row-wrap">
                        <div className="box-12 content-box">
                            <div className="customAnim slide-top is-animate">
                                <div className="inner-box">
                                    <div className="intro-box p-18 center-align text-center">
                                        <h1 className="heading has-line">{ content.legal_title }</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* inner-banner section end */ }

            <div className="legalfiles-box">
                <div className="container">
                    <div className="row-wrap fileslist">
                        {
                            content && !!content.legal_section.length && content.legal_section.map((obj, index) => {
                                return (
                                    <div className="box-12 box-md-6 box-lg-4 item-box" key={ index }>
                                        <div className="inner-box">
                                            <a href={process.env.PUBLIC_URL + obj.title.url} rel="noreferrer" target={obj.title.target}>
                                                <div className="card">
                                                    <div className="img-box">
                                                        {
                                                            obj.icon &&
                                                            <img src={ obj.icon.url } alt="icn" />
                                                        }
                                                        {
                                                            obj.hover_icon &&
                                                            <img className='hover-icon' src={ obj.hover_icon.url } alt="icn" />
                                                        }

                                                    </div>
                                                    <div className="info-box">
                                                        <p>{ obj.title.title }</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Legal;